import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Overline, Reveal } from "./Primitives";
import { PostCard } from "./PostCard";
import { useT } from "@/lib/i18n";
import { posts } from "@/lib/posts";

export const BlogTeaser = () => {
  const t = useT().blog;
  return (
    <section id="blog-teaser" className="py-24 md:py-36">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Overline>{t.over}</Overline>
            <h2 className="mt-6 font-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-3xl">{t.teaserTitle}</h2>
          </div>
          <Link to="/blog" data-testid="blog-teaser-all-link" className="btn-ghost">{t.all} <ArrowUpRight size={18} /></Link>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {posts.slice(0, 3).map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.1} className="h-full"><PostCard post={p} /></Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
